import React from "react";
import "./About.css"
import "../App.css"
import {Col, Container, Row} from "react-bootstrap";
import AboutFeatures from "../components/AboutFeatures";


const About = ()=>{
    return(
        <div>
            <div  className="about-section">
                <Container className="about-section-container">

                    <Row>
                        <h1 className="about-section-h1">About Anam Studio</h1>
                    </Row>
                    <Row>
                        <h3 className="about-sect-h3">
                            Unlock the Power of Creative Mastery with Anam Design Studio – where your visions are transformed into visual masterpieces. Explore a realm where quality, customization, punctuality, and satisfaction aren't just promises, they're our foundation.
                        </h3>
                        <div className="my-hr">
                            <hr/>
                        </div>
                    </Row>
                </Container>
            </div>
            <AboutFeatures/>

        </div>
)

}

export default About;